import { Sentry } from "@/lib/sentry";

function Fallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center px-6"
      style={{ backgroundColor: "var(--caileve-bg)" }}
    >
      <div className="max-w-md text-center">
        <h1
          className="text-3xl"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: "var(--caileve-lilac)",
          }}
        >
          Something went wrong.
        </h1>
        <p
          className="mt-4 text-base leading-relaxed"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: "var(--caileve-ink)",
          }}
        >
          Tap to reload.
        </p>
        <button
          type="button"
          onClick={() => {
            if (typeof window !== "undefined") window.location.reload();
          }}
          className="mt-6 px-6 py-2.5 text-xs uppercase tracking-[0.25em] text-white"
          style={{ backgroundColor: "var(--caileve-lilac)" }}
        >
          Reload
        </button>
        <p
          className="mt-6 text-sm"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", color: "var(--caileve-ink)" }}
        >
          Need help?{" "}
          <a href="mailto:hello@caileve.app" style={{ color: "var(--caileve-lilac)" }} className="underline">
            hello@caileve.app
          </a>
        </p>
      </div>
    </div>
  );
}

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}